import {Tooltip, Text, ButtonIcon} from '@blueprint/ui';

type ProjectFormTooltipProps = {
    className?: string;
};

export const ClaimApproversTooltip = ({
    className,
}: ProjectFormTooltipProps): JSX.Element => {
    const ClaimShowTips = "Approval request for claims will be sent out to the  claim approvers in parallel.";
    return (
        <Tooltip
            id="viewDataTooltipHover"
            placement="right"
            trigger={'click'}
            tooltip={<Text variant="body2">{ClaimShowTips}</Text>}
        >
            <ButtonIcon
                name="Help"
                className="mx-2"
                aria-label={ClaimShowTips}
                aria-describedby="viewDataTooltipHover"
            />
        </Tooltip>
    );
};

export const PaymentOrderApproversTooltip = ({
    className,
}: ProjectFormTooltipProps): JSX.Element => {
    const PaymentOrderApproversShowTips = "Approval requests for payment orders will be sent out to the payment order approvers in the specified sequence.";
    return (
        <Tooltip
            id="viewDataApproversTooltipHover"
            placement="right"
            trigger={'click'}
            tooltip={<Text variant="body2">{PaymentOrderApproversShowTips}</Text>}
        >
            <ButtonIcon
                name="Help"
                className="mx-2"
                aria-label={PaymentOrderApproversShowTips}
                aria-describedby="viewDataApproversTooltipHover"
            />
        </Tooltip>
    );
};
